// @flow

import I18n from '@insolus/i18n';
import Config from '@insolus/config';

type Options = {
    language?: 'fr' | 'de'
};

const __p = (path: string, options: Options = {}): string => {
    const currentLanguage = I18n.language;
    const language = options?.language ?? currentLanguage;
    if (Config.get('language.default') === language) {
        return path;
    }
    return `/${language}${path === '/' ? '' : path}`;
};

export default __p;
